import React from 'react';
import SEO from '../components/seo';
import Layout from '../components/layout';
import Header from '../components/header/header';
import Hero from '../components/our-story-page/hero';
// import Natalie from '../components/our-story-page/natalie';
import Steve from '../components/our-story-page/steve';
import BecomingFSD from '../components/our-story-page/fsd';
import CultureValue from '../components/our-story-page/culture-value';
import StickyNav from '../components/sticky-nav';

const OurStoryPage = () => (
  <Layout>
    <SEO title='Our Story' />
    <Header />
    <Hero />
    <Steve />
    {/* <Natalie /> */}
    <BecomingFSD />
    <CultureValue />
    <StickyNav />
  </Layout>
);

export default OurStoryPage;
